// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__AefLz","hamburger":"Nav_hamburger__o5+mt","open":"Nav_open__rdxbG","navLinks":"Nav_navLinks__3t4dw","logo":"Nav_logo__x4v73"};